
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies, import/extensions
import config from 'config';

const qs = require('qs');

const state = {
	campaigns: {},
	campaign: {},
};

const actions = {
	notificationsRegister: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios({
				method: 'POST',
				headers: { 'Content-Type': 'multipart/form-data' },
				url: `${config.api}/politician/${rootState.userId}/direct-message?api_key=${rootState.apiKey}`,
				data: payload,
			}).then((response) => {
				resolve(response);
				commit('setSuccess');
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data, { root: true });
				commit('statusCheck', error.response.status);
			});
		}),
	getCampaigns: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(`${config.api}/politician/${payload.userId}/direct-message?api_key=${payload.apiKey}&page=${payload.page}&results=${payload.results}`)
			.then((response) => {
				resolve(response);
				commit('setCampaigns', response.data);
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.status);
			});
	}),
	getCampaign: ({ commit }, payload) => new Promise((resolve) => {
		axios.get(`${config.api}/politician/${payload.userId}/direct-message/${payload.campaignId}?api_key=${payload.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('setCampaign', response.data);
			}, (error) => {
				commit('statusCheck', error.response.status);
			});
	}),
};
const mutations = {
	setCampaigns: (state, payload) => {
		state.campaigns = payload;
	},
	setCampaign(state, payload) {
		state.campaign = payload;
	},
	statusCheck: (state, payload) => {
		if (payload === 403) {
			sessionStorage.setItem('statusCode', payload);
		}
	}
};

export default {
	state,
	mutations,
	actions,
};




// WEBPACK FOOTER //
// ./_source/javascripts/modules/campaign/store.js